module.exports = __webpack_public_path__ + "img/jiangjin.a2af0007.svg";